<template>
	<div class="alert alert-danger" role="alert" :class="{ 'py-3': inModal }">
		<h4 v-if="!inModal" class="alert-heading">Error encountered.</h4>
		<p
			class="text-danger"
			:class="{
				'mb-0': (inModal && errorIsVisible) || !isFullError,
				'mb-3': inModal && !errorIsVisible && isFullError,
			}"
		>
			{{ message }}
		</p>
		<hr v-if="errorIsVisible" />
		<div v-if="errorIsVisible" class="max-height custom-scrollbar mb-3">
			<tree-view
				:data="errorObj"
				:options="{ rootObjectKey: 'error' }"
			></tree-view>
		</div>
		<button
			v-if="isFullError"
			type="button"
			class="btn btn-outline-danger"
			aria-label="Close"
			@click="showMore"
		>
			{{ errorIsVisible ? "Hide" : "See more" }}
		</button>
	</div>
</template>

<script>
import { errorCodeToText } from "../../util/error-messages";
export default {
	name: "ErrorAlert",
	props: ["error", "inModal"],
	data() {
		return {
			errorIsVisible: false,
		};
	},
	methods: {
		showMore: function () {
			this.errorIsVisible = !this.errorIsVisible;
		},
	},
	computed: {
		isFullError: function () {
			if (!this.error) return false;

			return !!this.error.response;
		},
		message: function () {
			if (!this.error) return "No message available";

			let err = this.error.response;

			if (err && err.data && err.data.message != "No message available") {
				return err.data.message;
			} else if (!this.isFullError) {
				return this.error.message;
			} else {
				return errorCodeToText[err.status] || "No message available";
			}
		},
		errorObj: function () {
			if (this.error && this.error.response) {
				return this.error.response.data;
			} else {
				return {};
			}
		},
	},
};
</script>

<style scoped>
.modal__controls {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
.modal__message {
	font-weight: bold;
	margin-bottom: 3rem;
}
.error-h {
	font-weight: bold;
	margin-bottom: 1rem;
}
.error-p {
	font-weight: normal;
	overflow-wrap: break-word;
	word-wrap: break-word;
}
.alert >>> .tree-view-item-leaf {
	white-space: normal;
}
</style>